import GridTable from "@/components/GridTable";
import { useWatchListContext } from "@/modules/Watchlist/hooks";
import { GridApi, GridReadyEvent, ICellRendererParams } from "ag-grid-community";
import React, { useState } from "react";
import { defaultColDef, editorColumns } from "./constants";
import TableControl from "./TableControl";
import DeleteBtn from "./DeleteBtn";

export default () => {
  const [gridApi, setGridApi] = useState<GridApi>();
  const { watchlistData } = useWatchListContext();

  return (
    <div style={{ minHeight: 300 }}>
      <TableControl gridApi={gridApi} />
      <GridTable
        animateRows
        extStyle={{ height: "100%" }}
        columnDefs={editorColumns}
        defaultColDef={defaultColDef}
        enableRangeSelection={false}
        onGridReady={onGridReady}
        rowData={watchlistData.map(e => ({ ...e, fullTicker: `${e.exchange}:${e.trading_code}` }))}
        rowDragManaged
        suppressHorizontalScroll
        enterMovesDownAfterEdit
        pagination={true}
        paginationPageSize={10}
        multiSortKey={"ctrl"}
        localeText={{ noRowsToShow: "No stock added in current watchlist." }}
        frameworkComponents={{
          deleteBtn: (params: ICellRendererParams) => (
            <DeleteBtn fullTicker={params.value}/>
          )
        }}
      />
    </div>
  );

  function onGridReady(params: GridReadyEvent) {
    setGridApi(params.api);
    params.api.refreshCells();
    params.columnApi.autoSizeAllColumns();
  }
};
